// @flow

export const STANDARD = 0;
export const ADDITIONAL = 1;
export const SPECIAL = 2;

export const assortmentLabels = {
  [STANDARD]: 'Standard',
  [ADDITIONAL]: 'Tilläggsprodukter',
  [SPECIAL]: 'Specialprodukter',
};

export const assortments = [{
  id: STANDARD,
  label: assortmentLabels[STANDARD],
}, {
  id: ADDITIONAL,
  label: assortmentLabels[ADDITIONAL],
}, {
  id: SPECIAL,
  label: assortmentLabels[SPECIAL],
}];



// WEBPACK FOOTER //
// ./src/assortments.js